import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const DigestiveDisordersPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Digestive Disorders</h1>
        <section className="mb-8">
          <p>Digestive disorders can range from mild discomfort to severe conditions affecting the stomach, intestines, and other parts of the digestive system. Natural therapies can help soothe symptoms, improve digestion, and support overall gut health.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Poor diet</li>
            <li>Stress</li>
            <li>Food intolerances</li>
            <li>Infections</li>
            <li>Lifestyle factors</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Abdominal pain or cramping</li>
            <li>Bloating or gas</li>
            <li>Diarrhea or constipation</li>
            <li>Nausea or vomiting</li>
            <li>Loss of appetite</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use soothing herbs, dietary guidance, and gentle therapies to balance the digestive system, reduce symptoms, and promote overall gut health. Each plan is tailored to your needs for safe, effective care.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Reduces digestive discomfort</li>
            <li>Improves gut health</li>
            <li>No harsh side effects</li>
            <li>Personalized, gentle care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eat a balanced, fiber-rich diet</li>
            <li>Stay hydrated</li>
            <li>Manage stress</li>
            <li>Regular physical activity</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment help with chronic digestive issues?</strong>
            <p>A: Yes, our approach can support long-term digestive health and symptom relief.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for sensitive stomachs?</strong>
            <p>A: Yes, our remedies are gentle and soothing.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I feel relief?</strong>
            <p>A: Many patients notice improvement within a few weeks.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find digestive comfort—book your natural gut health consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default DigestiveDisordersPage; 